'use strict';

var ChartForecastProfileViewDirective = function ChartForecastProfileViewDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-forecast-profile-view.html'),
    controller: 'ChartForecastProfileViewController',
    scope: {
      attributes: '=',
      dimension: '=',
      quickFilterData: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters, scope.interpolate);
      scope.renderChartDataPresent = function renderChart(data) {
        chart.render(data, scope.verticalLineData);
      };
      function paramsChanged(ignoreVisibility) {
        var isVisible = ignoreVisibility || element.is(':visible');
        var parametersDefined = scope.attributes && scope.dimension && scope.quickFilterData;
        scope.setLoadingMessage(parametersDefined ? 'Loading' : 'No data found');
        if (isVisible && parametersDefined) {
          scope.initChart();
        }
      }
      scope.$on('forecast-profile-chart:redraw', function () {
        paramsChanged(true);
      });
      scope.$watchGroup(['attributes', 'dimension'], function () {
        paramsChanged(false);
      });
      scope.$watch('quickFilterData', function () {
        paramsChanged(false);
      }, true);
    }
  };
};
ChartForecastProfileViewDirective.$inject = ['ChartForecastProfileView'];
module.exports = ChartForecastProfileViewDirective;